import React, { useRef, useEffect } from 'react';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';

// Setting the editable property in lexical's editor config will completely freeze everything
// including the click interactions that tags have. In order to maintain this feature in readonly
// mode, we must use a custom content editable element.
// https://github.com/facebook/lexical/issues/2164
const ReadOnlyContentEditable = ({
  className
}: {
  className: string;
}) => {
  const [editor] = useLexicalComposerContext();
  const editorRef = useRef(null);
  useEffect(() => {
    if (editor && editorRef.current) {
      editor.setRootElement(editorRef.current);
    }
    return () => {
      if (editor) {
        editor.setRootElement(null);
      }
    };
  }, [editor]);
  return <div className={className} contentEditable={false} ref={editorRef} />;
};
export default ReadOnlyContentEditable;